/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

(function () {
  var refreshTimer;
  var unlockFrame;
  var bodyObserver;
  var overlayObserver;
  var observedOverlay;

  function refreshBuddyCart(options) {
    options = options || {};

    if (typeof CartDrop === 'function') {
      CartDrop(options.openDrawer === true ? false : true);
      return;
    }

    if (!window.theme || !theme.routes_cart_url) {
      return;
    }

    fetch(theme.routes_cart_url + '?section_id=cart-dropdown')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextDropdown = doc.querySelector('#cart-dropdown');
        var currentDropdown = document.querySelector('#cart-dropdown');
        var nextCount = doc.querySelector('.cartCountSelector');
        var nextTotal = doc.querySelector('.cartTotalSelector');

        if (nextDropdown && currentDropdown) {
          currentDropdown.innerHTML = nextDropdown.innerHTML;
          currentDropdown.setAttribute('data-items', nextDropdown.getAttribute('data-items') || '0');
          currentDropdown.setAttribute('data-total', nextDropdown.getAttribute('data-total') || '');
        }

        if (nextCount) {
          document.querySelectorAll('.cartCountSelector').forEach(function (node) {
            node.textContent = nextCount.textContent;
          });
        }

        if (nextTotal) {
          document.querySelectorAll('.cartTotalSelector').forEach(function (node) {
            node.innerHTML = nextTotal.innerHTML;
          });
        }
      }).catch(function (err) {
        console.error('Buddy cart refresh failed: ' + err);
      });
  }

  function scheduleBuddyCartRefresh(options) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshBuddyCart(options);
    }, 250);
  }

  function requestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input && input.url) {
      return input.url;
    }

    return '';
  }

  function requestMethod(input, init) {
    if (init && init.method) {
      return init.method.toUpperCase();
    }

    if (input && input.method) {
      return input.method.toUpperCase();
    }

    return 'GET';
  }

  function isCartAddRequest(input, init) {
    var url = requestUrl(input);

    return url.indexOf('/cart/add') !== -1 && requestMethod(input, init) === 'POST';
  }

  function isCartEndpointUrl(url) {
    return url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/clear') !== -1;
  }

  function withoutOpusQuery(url) {
    var hash = '';
    var hashIndex;
    var queryIndex;
    var base;
    var params;

    if (!url || url.indexOf('opus=') === -1 || !isCartEndpointUrl(url)) {
      return url;
    }

    hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
      hash = url.slice(hashIndex);
      url = url.slice(0, hashIndex);
    }

    queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
      return url + hash;
    }

    base = url.slice(0, queryIndex);
    params = url.slice(queryIndex + 1).split('&').filter(function (param) {
      var name = param.split('=')[0].replace(/\+/g, ' ');

      try {
        name = decodeURIComponent(name);
      } catch (error) {
        return true;
      }

      return name !== 'opus';
    });

    return base + (params.length ? '?' + params.join('&') : '') + hash;
  }

  function normalizeCartEndpointInput(input) {
    var nextUrl = withoutOpusQuery(requestUrl(input));

    if (!nextUrl || nextUrl === requestUrl(input)) {
      return input;
    }

    if (typeof input === 'string') {
      return nextUrl;
    }

    if (typeof Request !== 'undefined' && input instanceof Request) {
      return new Request(nextUrl, input);
    }

    return input;
  }

  function privatePropertyName(name) {
    if (name === 'properties[discount_key]') {
      return 'properties[_discount_key]';
    }

    if (name === 'properties[PriceCalculation]') {
      return 'properties[_PriceCalculation]';
    }

    return null;
  }

  function sanitizeClOptionsJson(value) {
    var data;

    if (typeof value !== 'string') {
      return value;
    }

    try {
      data = JSON.parse(value);
    } catch (error) {
      return value;
    }

    if (!data || typeof data !== 'object') {
      return value;
    }

    delete data.discount_key;
    delete data.PriceCalculation;

    return JSON.stringify(data);
  }

  function sanitizePropertyValue(name, value) {
    if (name === 'properties[_cl_options_json]') {
      return sanitizeClOptionsJson(value);
    }

    return value;
  }

  function sanitizeFormDataBody(body) {
    var nextBody = new FormData();

    body.forEach(function (value, name) {
      var privateName = privatePropertyName(name);
      var nextValue = sanitizePropertyValue(name, value);

      if (privateName) {
        nextBody.set(privateName, nextValue);
      } else {
        nextBody.append(name, nextValue);
      }
    });

    return nextBody;
  }

  function sanitizeUrlSearchParamsBody(body) {
    var nextBody = new URLSearchParams();

    body.forEach(function (value, name) {
      var privateName = privatePropertyName(name);
      var nextValue = sanitizePropertyValue(name, value);

      if (privateName) {
        nextBody.set(privateName, nextValue);
      } else {
        nextBody.append(name, nextValue);
      }
    });

    return nextBody;
  }

  function sanitizeJsonBody(body) {
    var data;

    try {
      data = JSON.parse(body);
    } catch (error) {
      return body;
    }

    if (!data || !data.properties) {
      return body;
    }

    if (Object.prototype.hasOwnProperty.call(data.properties, '_cl_options_json')) {
      data.properties._cl_options_json = sanitizeClOptionsJson(data.properties._cl_options_json);
    }

    if (Object.prototype.hasOwnProperty.call(data.properties, 'discount_key')) {
      data.properties._discount_key = data.properties.discount_key;
      delete data.properties.discount_key;
    }

    if (Object.prototype.hasOwnProperty.call(data.properties, 'PriceCalculation')) {
      data.properties._PriceCalculation = data.properties.PriceCalculation;
      delete data.properties.PriceCalculation;
    }

    return JSON.stringify(data);
  }

  function sanitizeBody(body) {
    if (!body) {
      return body;
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return sanitizeFormDataBody(body);
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return sanitizeUrlSearchParamsBody(body);
    }

    if (typeof body === 'string') {
      if (body.indexOf('properties%5Bdiscount_key%5D') !== -1 ||
        body.indexOf('properties%5BPriceCalculation%5D') !== -1 ||
        body.indexOf('properties[discount_key]') !== -1 ||
        body.indexOf('properties[PriceCalculation]') !== -1
      ) {
        return sanitizeUrlSearchParamsBody(new URLSearchParams(body)).toString();
      }

      return sanitizeJsonBody(body);
    }

    return body;
  }

  function sanitizeCartAddInit(init) {
    if (!init || !init.body) {
      return init;
    }

    var nextInit = {};

    Object.keys(init).forEach(function (key) {
      nextInit[key] = init[key];
    });

    nextInit.body = sanitizeBody(init.body);

    return nextInit;
  }

  function installCartAddObserver() {
    if (window.__buddyCartAddObserverInstalled || typeof window.fetch !== 'function') {
      return;
    }

    window.__buddyCartAddObserverInstalled = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var fetchInput = normalizeCartEndpointInput(input);
      var shouldRefreshCart = isCartAddRequest(fetchInput, init);
      var fetchInit = shouldRefreshCart ? sanitizeCartAddInit(init) : init;

      return originalFetch.call(this, fetchInput, fetchInit).then(function (response) {
        if (shouldRefreshCart && response.ok) {
          scheduleBuddyCartRefresh({ openDrawer: false });
        }

        return response;
      });
    };
  }

  function scheduleCartDrawerUnlockSweep() {
    scheduleUnlockOpusOverlay();
    window.setTimeout(scheduleUnlockOpusOverlay, 250);
    window.setTimeout(scheduleUnlockOpusOverlay, 900);
    window.setTimeout(scheduleUnlockOpusOverlay, 1800);
  }

  function installCartDropObserver() {
    if (window.__buddyCartDropObserverInstalled || typeof window.CartDrop !== 'function') {
      return;
    }

    window.__buddyCartDropObserverInstalled = true;

    var originalCartDrop = window.CartDrop;
    window.CartDrop = function () {
      var result = originalCartDrop.apply(this, arguments);
      scheduleCartDrawerUnlockSweep();
      return result;
    };
  }

  function installThirdPartyBlockerStyles() {
    var style;

    if (document.getElementById('buddy-third-party-blocker-styles')) {
      return;
    }

    style = document.createElement('style');
    style.id = 'buddy-third-party-blocker-styles';
    style.textContent = '.commonninja_component[class*="hid-"]{pointer-events:none!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function isCartPage() {
    return Boolean(
      document.getElementById('cart-table') ||
      document.querySelector('[data-section-type="cart_page"]')
    );
  }

  function isVisibleElement(element) {
    var rect;
    var style;

    if (!element || typeof element.getBoundingClientRect !== 'function') {
      return false;
    }

    rect = element.getBoundingClientRect();
    style = typeof window.getComputedStyle === 'function' ? window.getComputedStyle(element) : null;

    if (style && (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      Number(style.opacity) === 0
    )) {
      return false;
    }

    return rect.width > 0 && rect.height > 0;
  }

  function hasVisibleOverlayChild(overlay) {
    var index;

    if (!overlay || !overlay.children) {
      return false;
    }

    for (index = 0; index < overlay.children.length; index += 1) {
      if (isVisibleElement(overlay.children[index])) {
        return true;
      }
    }

    return false;
  }

  function hasVisibleOpusShadowCartAction(overlay) {
    var shadowRoot;
    var text;
    var actions;
    var index;
    var actionText;

    if (isCartPage()) {
      return false;
    }

    if (!overlay || !overlay.shadowRoot || typeof overlay.shadowRoot.querySelectorAll !== 'function') {
      return false;
    }

    shadowRoot = overlay.shadowRoot;
    text = shadowRoot.textContent || '';

    if (!/dein warenkorb|warenkorb ansehen|jetzt sicher|checkout|zur kasse|bezahlen/i.test(text)) {
      return false;
    }

    actions = shadowRoot.querySelectorAll('button, a, input, [role="button"]');
    for (index = 0; index < actions.length; index += 1) {
      actionText = (actions[index].textContent || '') + ' ' +
        (actions[index].value || '') + ' ' +
        (actions[index].getAttribute('aria-label') || '') + ' ' +
        (actions[index].getAttribute('href') || '');

      if (isVisibleElement(actions[index]) &&
        /warenkorb ansehen|jetzt sicher|checkout|zur kasse|bezahlen/i.test(actionText)
      ) {
        return true;
      }
    }

    return false;
  }

  function hasStaleOpusBodyClass() {
    return document.body.classList.contains('opus-modal-open') ||
      document.body.classList.contains('opus-drawer-open');
  }

  function clearStaleOpusBodyClasses() {
    if (!document.body || !document.body.classList || typeof document.body.classList.remove !== 'function') {
      return;
    }

    document.body.classList.remove('opus-modal-open', 'opus-drawer-open');
  }

  function hasActiveOpusSurface(overlay) {
    var activeSurface = document.querySelector(
      '[aria-modal="true"], #opus-shadow-container .open, #opus-shadow-container .active, #opus-shadow-container [aria-hidden="false"]'
    );

    if (isVisibleElement(activeSurface)) {
      return true;
    }

    if (hasVisibleOverlayChild(overlay)) {
      return true;
    }

    if (hasVisibleOpusShadowCartAction(overlay)) {
      return true;
    }

    if (hasStaleOpusBodyClass()) {
      clearStaleOpusBodyClasses();
      return false;
    }

    return false;
  }

  function hasOpenCartDropdown() {
    var dropdown = document.getElementById('cart-dropdown');
    var cartAction;

    if (!dropdown || !/warenkorb|bezahlen|checkout|zur kasse/i.test(dropdown.textContent || '')) {
      return false;
    }

    if (isVisibleElement(dropdown)) {
      return true;
    }

    if (typeof dropdown.querySelectorAll !== 'function') {
      return false;
    }

    cartAction = Array.prototype.slice.call(dropdown.querySelectorAll('a, button, input, [role="button"]')).filter(function (element) {
      return isVisibleElement(element) &&
        /warenkorb ansehen|bezahlen|checkout|zur kasse/i.test((element.textContent || '') + ' ' + (element.value || ''));
    });

    return cartAction.length > 0;
  }

  function isHiddenCommonNinjaBlocker(blocker) {
    return /\bhid-/.test(String(blocker.className || ''));
  }

  function unlockCartDrawerThirdPartyBlockers() {
    var cartDropdownOpen = hasOpenCartDropdown();
    var blockers = document.querySelectorAll('.commonninja_component');
    var index;
    var pointerEvents;

    for (index = 0; index < blockers.length; index += 1) {
      pointerEvents = cartDropdownOpen || isHiddenCommonNinjaBlocker(blockers[index]) ? 'none' : '';
      if (blockers[index].style.pointerEvents !== pointerEvents) {
        blockers[index].style.pointerEvents = pointerEvents;
      }
    }
  }

  function unlockOpusOverlayOnCartPage() {
    var overlay = document.getElementById('opus-shadow-container');

    unlockCartDrawerThirdPartyBlockers();

    if (!overlay) {
      return;
    }

    // Buddy: Auf der Warenkorbseite den Opus-Cart-Drawer KOMPLETT ausblenden.
    // Die Seite ist selbst der Warenkorb; das Opus-Drawer ist hier redundant und
    // oeffnet als blockierendes Modal. Opus erzwingt display:block per Inline-
    // !important -> daher per JS mit !important ueberschreiben. Der bestehende
    // observeOpusOverlay-/Body-Observer re-applied das bei jeder Opus-Re-Oeffnung.
    // display:none am Host rendert auch den Shadow-Tree nicht (kein Durchscheinen).
    if (isCartPage()) {
      if (overlay.style.getPropertyValue('display') !== 'none') {
        overlay.style.setProperty('display', 'none', 'important');
      }
      if (overlay.style.getPropertyValue('pointer-events') !== 'none') {
        overlay.style.setProperty('pointer-events', 'none', 'important');
      }
      clearStaleOpusBodyClasses();
      return;
    }

    var pointerEvents = hasActiveOpusSurface(overlay) ? '' : 'none';

    if (overlay.style.pointerEvents !== pointerEvents) {
      overlay.style.pointerEvents = pointerEvents;
    }
  }

  function observeOpusOverlay() {
    var overlay = document.getElementById('opus-shadow-container');

    if (!overlay || overlay === observedOverlay) {
      return;
    }

    if (overlayObserver) {
      overlayObserver.disconnect();
    }

    observedOverlay = overlay;
    overlayObserver = new MutationObserver(scheduleUnlockOpusOverlay);
    overlayObserver.observe(overlay, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  function scheduleUnlockOpusOverlay() {
    if (unlockFrame) {
      return;
    }

    unlockFrame = window.requestAnimationFrame(function () {
      unlockFrame = null;
      observeOpusOverlay();
      unlockOpusOverlayOnCartPage();
    });
  }

  function installOpusOverlayObserver() {
    if (bodyObserver || !document.body) {
      return;
    }

    bodyObserver = new MutationObserver(scheduleUnlockOpusOverlay);
    bodyObserver.observe(document.body, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  window.BuddyCartSync = {
    refresh: refreshBuddyCart,
    scheduleRefresh: scheduleBuddyCartRefresh,
    unlockOpusOverlay: scheduleUnlockOpusOverlay,
    unlockCartDrawer: scheduleCartDrawerUnlockSweep
  };

  window.BuddyCartPropertySanitizer = {
    sanitizeBody: sanitizeBody
  };

  document.addEventListener('cartItems', function () {
    scheduleBuddyCartRefresh({ openDrawer: false });
    scheduleUnlockOpusOverlay();
  });

  document.addEventListener('DOMContentLoaded', function () {
    installThirdPartyBlockerStyles();
    installCartAddObserver();
    installCartDropObserver();
    installOpusOverlayObserver();
    scheduleUnlockOpusOverlay();
  });
})();

/* Opus-Drawer Anzeige-Korrekturen (2026-06-10): Du-Form + lesbare Mass-Properties.
   Reine Anzeige-Schicht im offenen Shadow-DOM des Opus-Carts (#opus-shadow-container).
   Kein Eingriff in App-Daten, LPO-Properties oder Preise. Idempotent:
   nach dem Rewrite matchen die Muster nicht erneut. */
(function () {
  var DIM_NAME = /^(Polyc|Abmessung VSG):?$/;
  var DIM_VALUE = /^(\d{2,4})x(\d{2,4})$/;
  function rewriteOpusTexts(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('span, div, h5, p, b, strong');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length !== 0) continue;
      var t = el.textContent;
      if (!t) continue;
      var trimmed = t.trim();
      if (DIM_NAME.test(trimmed)) {
        el.textContent = t.replace(/Polyc|Abmessung VSG/, 'Maß');
      } else if (DIM_VALUE.test(trimmed)) {
        el.textContent = trimmed.replace(DIM_VALUE, '$1 x $2 cm');
      } else if (trimmed.indexOf('Sie sparen') !== -1) {
        el.textContent = t.replace('Sie sparen', 'Du sparst');
      }
    }
  }
  function armOpusTextRewrite() {
    var sc = document.getElementById('opus-shadow-container');
    if (!sc || !sc.shadowRoot) return false;
    var sr = sc.shadowRoot;
    rewriteOpusTexts(sr);
    var obs = new MutationObserver(function () {
      obs.disconnect();
      rewriteOpusTexts(sr);
      obs.observe(sr, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(sr, { childList: true, subtree: true, characterData: true });
    return true;
  }
  if (!armOpusTextRewrite()) {
    var opusRewriteTries = 0;
    var opusRewriteTimer = window.setInterval(function () {
      opusRewriteTries += 1;
      if (armOpusTextRewrite() || opusRewriteTries > 40) {
        window.clearInterval(opusRewriteTimer);
      }
    }, 500);
  }
})();
